module.exports = __webpack_public_path__ + "img/569.75356a03.jpg";